import React, { Component } from "react";
import { Div, Text, Input, Button, Row, Col } from "atomize";
import InnerHTML from "../../utilities/innerHtml";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";
import PrimaryButton from "../common/PrimaryButton";

export default class CampaingBuilder extends Component {
  render() {
    const { content, imagePC, form } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{ t: { xs: "4.2rem", md: "10.5rem" } }} className="solutions">
            <Row>
              <Col d={{ xs: "block", md: "none" }} size="12">
                <ImageLink link={content.imgMobileLink}>
                  <Div
                    bgImg={content.imgMobile}
                    bgSize="cover"
                    bgPos="center"
                    p={{ b: "95.3%" }}
                    m={{ b: " 2.6rem" }}
                  ></Div>
                </ImageLink>
              </Col>
              <Col size={{ xs: "12", md: "6" }}>
                <Div d="flex" flexDir="column" h="100%" justify="space-between">
                  <Div>
                    <Text
                      m={{ b: ".8rem" }}
                      p={{ r: { xs: "0", lg: "3rem" } }}
                      textSize="title2"
                      textWeight="700"
                      tag="h2"
                    >
                      {content.heading}
                    </Text>
                    <Text
                      m={{ b: "2rem" }}
                      p={{ r: { xs: "0", lg: "3rem" } }}
                      className="sub-text"
                      textSize={{ xs: "15px", md: "paragraph" }}
                      textColor="#D9D9D9"
                    >
                      {content.text}
                    </Text>
                  </Div>
                  <Div
                    // d={{ xs: "none", md: "block" }}
                    m={{ r: { lg: "2rem" } }}
                  >
                    <Text
                      m={{ b: ".5rem" }}
                      fontFamily="secondary"
                      textWeight="700"
                      d={{ xs: "none", md: "block" }}
                    >
                      {content.text2}
                    </Text>
                    {/* {typeof window !== "undefined" && (
                      <InnerHTML html={updateActiveCampaignForm(form)} />
                    )} */}
                    <PrimaryButton
                      className="hero-action-btn"
                      bg="primary"
                      fontFamily="primary"
                      hoverBg="#FFCB6F"
                      textTransform="none"
                      textColor="black"
                      h="3.125rem"
                      border="none"
                      p="0 1.25rem"
                      w={{ xs: "100%", md: "auto" }}
                      textWeight="800"
                      onClick={
                        () =>
                          (window.location.href = "https://trend.io/pricing")
                        // hero.hero.heroBtnPrimary.link)
                      }
                    >
                      {/* {hero.hero.heroBtnPrimary.text} */}
                      Start a Free Campaign
                    </PrimaryButton>
                  </Div>
                </Div>
              </Col>
              <Col
                d={{ xs: "none", md: "block" }}
                style={{ margin: "auto" }}
                size={{ xs: "12", md: "6" }}
              >
                <ImageLink link={content.imgPCLink}>
                  <Div
                    bgImg={content.imgPC}
                    bgSize="cover"
                    bgPos="center"
                    p={{ b: "95.3%" }}
                  ></Div>
                </ImageLink>
              </Col>
            </Row>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
